import Vue from 'vue'
import App from './App.vue'
import router from './router';
import "./js/flexible"; // 引入lib-flexible库，用于动态设置根元素的字体大小
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/font/font.css'
import '@/global.scss'

Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.prototype.skipPage = function(route) {
  if(typeof route === 'string')
    router.push(route);
  else {
    router.push(route.router);
    if(route.className) { // 有锚点，锚点跳转
      document.getElementsByClassName(route.className)[0].scrollIntoView();
    }
  }
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
